// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__nvnX8","inner":"BackButton_inner__vAYeT","svg":"BackButton_svg__W8I33"};